import { add, isValid, sub } from "date-fns"

export var dateExpressionRegex =   /^\([a-zA-Z0-9\-+_ ]*\)([< >]*)\([a-zA-Z0-9\-+_ ]*\)$/
export var dateFormatRegex =       /^[0-9]{2}\/[0-9]{2}\/[0-9]{4}$/
export var dateIsoFormatRegex =    /^[0-9]{4}-[0-9]{2}-[0-9]{2}$/

export function evaluateDateString (answers, dateString: string): Date {

    // input should be formatted as a date string or dynamically like this:
    //      "current_date+1y"

    try {
        dateString = dateString.replaceAll(" ", "")

        if (dateString === "current_date") {
            return new Date()
        }
        if (dateString.match(dateFormatRegex) || dateString.match(dateIsoFormatRegex)) {
            return new Date(dateString)
        }
        
        var sumString = dateString.match(/(\+|-)[0-9]{1,1000}(y|m|d)/)?.find(str => !!str)
        var fieldName = sumString ? dateString.replaceAll(sumString, "") : dateString
        var fieldValue = fieldName === "current_date" ? new Date() : new Date(answers[fieldName])

        if (!isValid(fieldValue)) {
            console.log("Failed to parse date", dateString, fieldValue)
            return null
        }

        if (!sumString) {
            return fieldValue
        }   
        
        var interval = parseInt(sumString.replaceAll(/\D/g,''))
        var intervalSettings = {
            days: sumString.includes("d") ? interval : 0,
            months: sumString.includes("m") ? interval : 0,
            years: sumString.includes("y") ? interval : 0,
        }
        var newDate = sumString[0] === "+" ? add(fieldValue, intervalSettings) : sub(fieldValue, intervalSettings)
        return newDate

    } catch (e) {
        console.log("Error while parsing date boundary", dateString, e)
        return null
    }
}

export function evaluateDateExpressionString (answers, expressionString: string): boolean {

    // To be used for dependsOn conditions.
    
    // Input should be formatted like this:
    //     "(current_date) > (subject_date_of_birth - 1y)"

    try {
        expressionString = expressionString.replaceAll(" ", "").toLowerCase()

        if (!expressionString.match(dateExpressionRegex)) {
            return null
        }

        var expressionVariables = Array.from(expressionString.matchAll(/(?<=\().+?(?=\))/g))

        if (expressionVariables.length !== 2) {
            console.log("Failed to parse date expression", expressionString, expressionVariables)
            return null
        }

        var leftHandVariable = evaluateDateString(answers, expressionVariables[0][0])
        var rightHandVariable = evaluateDateString(answers, expressionVariables[1][0])

        if (leftHandVariable == null || rightHandVariable == null) {
            console.log("Failed to parse date expression", leftHandVariable, rightHandVariable)
            return null  
        } 

        if (expressionString.includes("<")) {
            return leftHandVariable < rightHandVariable
        }

        if (expressionString.includes(">")) {
            return leftHandVariable > rightHandVariable
        }

        return null
    } catch (e) {
        console.log("Error while parsing date boundary", expressionString, e)
        return null
    }
}